import i18n from "i18next"
import Backend from "i18next-chained-backend"
import HttpApi from "i18next-http-backend"
// import LocalStorageBackend from "i18next-localstorage-backend" // primary use cache
import { initReactI18next, useTranslation } from "react-i18next"
import { apiPaths } from "./models/i18n"
import { localStorageOrCookieLanguage } from "./Utils"
import { useCallback } from "react"

const dev = process.env.NODE_ENV === "development"

const language = localStorageOrCookieLanguage()

i18n.use(Backend)
    .use(initReactI18next)
    .init(
        {
            backend: {
                // TODO turn it on before going live (also line 18(!!!) and 4)
                // backends: [LocalStorageBackend, HttpApi],
                backends: [HttpApi],
                backendOptions: [
                    {
                        loadPath: `/api/v1${apiPaths.getLocale("{{lng}}")}`,
                    },
                ],
            },
            ns: [language || "de"],
            fallbackLng: "de",
            lng: language || "de",
            defaultNS: "de",
            debug: false,
            interpolation: {
                escapeValue: false,
            },
            saveMissing: false,
            missingKeyHandler: dev && ((_: any, ns: string, key: string) => console.error("[i18n] Missing key: %s", ns === "default" ? key : `${ns}/${key}`)),
        },
        (err) => {
            err && console.error(err)
        },
    )

export function useTranslationOrUndefined() {
    const { t } = useTranslation()
    return useCallback(
        (key: string | undefined | null) => {
            if (!key) return undefined
            else return t(key)
        },
        [t],
    )
}

export default i18n
